import React from 'react';
import { connect } from 'react-redux';
import ArtifactViewMainContent from '~/artifact/containers/ArtifactViewMainContent';
import { vulnSectionsMap } from '~/constants/ModelConstants';
import PermissionsHelper from '~/utils/PermissionsHelper';
type ArtifactViewProps = {
  artifactState: object;
  myState: object;
  orgState: object;
};
class ArtifactView extends React.Component<ArtifactViewProps, {}> {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    const { myState, orgState } = this.props;
    const isLoggedInAndPaidOrTrialing = PermissionsHelper.isLoggedInAndPaidOrTrialing(
      myState,
      orgState
    );
    const showPaywallCTA = !isLoggedInAndPaidOrTrialing;
    //List of sections to be paywalled. This automatically hides the display of sections listed.
    const maybePaywalledContent = showPaywallCTA
      ? [vulnSectionsMap.EXPLOIT_INFORMATION, vulnSectionsMap.VULNERABLE_METHODS]
      : [];
    return (
      <section className="grid">
        <div className="grid__item">
          <ArtifactViewMainContent paywalledContent={maybePaywalledContent} />
        </div>
      </section>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    myState: state.myState,
    orgState: state.orgState,
    routing: state.routing,
  };
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactView);
